export enum CategoriesMobileFiltersVisibilityStates {
  List,
  SortBy,
  FilterByName,
  FilterByKeyword,
}
